export const GET_TAX_CONDITIONS = `
  query taxConditions(
    $tenant_id: Int!
    $skip: Int
    $take: Int
    $filter: FilterTaxConditionInput
    $orderBy: TaxConditionOrderInput
    $searchText: String
  ) {
    taxConditions(
      tenant_id: $tenant_id
      skip: $skip
      take: $take
      filter: $filter
      orderBy: $orderBy
      searchText: $searchText
    ) {
      __typename
      ... on TaxCondition {
        id
        name
        category
        active
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
    totalTaxConditions(tenant_id: $tenant_id, filter: $filter, searchText: $searchText)
  }
`;

export const GET_TAX_CONDITION = `
  query taxCondition($id: Int!, $tenant_id: Int!) {
    taxCondition(id: $id, tenant_id: $tenant_id) {
      __typename
      ... on TaxCondition {
        id
        name
        category
        active
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
